import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, toHandlers as _toHandlers, mergeProps as _mergeProps, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, withKeys as _withKeys, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "modal-wrap default-modal" }
const _hoisted_2 = {
  class: "modal fade lg-size",
  id: "addPhaseModal",
  tabindex: "-1",
  "aria-labelledby": "addModalLabel",
  "aria-hidden": "true",
  "data-backdrop": "static",
  "data-keyboard": "false"
}
const _hoisted_3 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = {
  key: 0,
  class: "modal-header"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("h5", {
  class: "modal-title",
  id: "addModalLabel"
}, "Edit Phase", -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_8 = {
  key: 1,
  class: "modal-header"
}
const _hoisted_9 = {
  key: 0,
  class: "modal-title",
  id: "addModalLabel"
}
const _hoisted_10 = {
  key: 1,
  class: "modal-title",
  id: "addModalLabel"
}
const _hoisted_11 = {
  key: 2,
  class: "modal-title",
  id: "addModalLabel"
}
const _hoisted_12 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_13 = { class: "modal-body" }
const _hoisted_14 = {
  key: 0,
  class: "form-group"
}
const _hoisted_15 = { class: "project-budget-block" }
const _hoisted_16 = { class: "project-info-budget" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = /*#__PURE__*/_createVNode("i", { class: "fas fa-info-circle" }, null, -1)
const _hoisted_19 = { key: 1 }
const _hoisted_20 = /*#__PURE__*/_createVNode("i", { class: "fas fa-info-circle" }, null, -1)
const _hoisted_21 = { class: "project-info-budget date-wrap d-flex" }
const _hoisted_22 = {
  key: 0,
  for: "exampleInputEmail1"
}
const _hoisted_23 = /*#__PURE__*/_createVNode("i", { class: "far fa-calendar" }, null, -1)
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" Project Date ")
const _hoisted_25 = {
  key: 1,
  for: "exampleInputEmail1"
}
const _hoisted_26 = /*#__PURE__*/_createVNode("i", { class: "far fa-calendar" }, null, -1)
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" Phase Date ")
const _hoisted_28 = { title: "Start Date" }
const _hoisted_29 = /*#__PURE__*/_createVNode("li", null, "-", -1)
const _hoisted_30 = { title: "End Date" }
const _hoisted_31 = { class: "form-wrap pt-0" }
const _hoisted_32 = { class: "form-group" }
const _hoisted_33 = {
  key: 0,
  for: "exampleInputEmail1"
}
const _hoisted_34 = {
  key: 1,
  for: "exampleInputEmail1"
}
const _hoisted_35 = { class: "form-group" }
const _hoisted_36 = /*#__PURE__*/_createVNode("label", { for: "exampleInputEmail1" }, "Description", -1)
const _hoisted_37 = { class: "row" }
const _hoisted_38 = { class: "col-md-6" }
const _hoisted_39 = { class: "form-group" }
const _hoisted_40 = /*#__PURE__*/_createVNode("label", { for: "exampleInputEmail1" }, "Priority", -1)
const _hoisted_41 = /*#__PURE__*/_createVNode("option", { value: "3" }, "High", -1)
const _hoisted_42 = /*#__PURE__*/_createVNode("option", { value: "2" }, "Medium", -1)
const _hoisted_43 = /*#__PURE__*/_createVNode("option", { value: "1" }, "low", -1)
const _hoisted_44 = { class: "col-md-6" }
const _hoisted_45 = {
  key: 0,
  class: "col-md-6 px-2"
}
const _hoisted_46 = { class: "form-group" }
const _hoisted_47 = /*#__PURE__*/_createVNode("label", { for: "exampleInputEmail1" }, "Estimated Budget", -1)
const _hoisted_48 = {
  key: 1,
  class: "col-md-6 px-2"
}
const _hoisted_49 = { class: "form-group" }
const _hoisted_50 = /*#__PURE__*/_createVNode("label", { for: "exampleInputEmail1" }, "Estimate Budget", -1)
const _hoisted_51 = /*#__PURE__*/_createVNode("label", { for: "vehicle1" }, "Percentage", -1)
const _hoisted_52 = { class: "form-group bg-light p-3" }
const _hoisted_53 = {
  key: 0,
  for: "exampleInputEmail1"
}
const _hoisted_54 = { class: "row mx-n2" }
const _hoisted_55 = { class: "col-md-6 px-2" }
const _hoisted_56 = { class: "form-group" }
const _hoisted_57 = /*#__PURE__*/_createVNode("label", { for: "" }, "Start Date", -1)
const _hoisted_58 = { class: "col-md-6 px-2" }
const _hoisted_59 = { class: "form-group" }
const _hoisted_60 = /*#__PURE__*/_createVNode("label", { for: "exampleInputEmail1" }, "End Date", -1)
const _hoisted_61 = {
  key: 0,
  class: "col-md-12 px-2"
}
const _hoisted_62 = { class: "form-group" }
const _hoisted_63 = /*#__PURE__*/_createVNode("label", { for: "exampleInputEmail1" }, "Add Existing Member", -1)
const _hoisted_64 = {
  key: 1,
  class: "col-md-12 px-2"
}
const _hoisted_65 = { class: "form-group" }
const _hoisted_66 = /*#__PURE__*/_createVNode("label", { for: "exampleInputEmail1" }, "Add New Member", -1)
const _hoisted_67 = { class: "input-btn" }
const _hoisted_68 = /*#__PURE__*/_createVNode("i", { class: "fas fa-plus" }, null, -1)
const _hoisted_69 = {
  key: 0,
  class: "table-add-phase"
}
const _hoisted_70 = { class: "table table-bordered table-limit-input" }
const _hoisted_71 = {
  key: 0,
  scope: "col",
  title: "Contractor"
}
const _hoisted_72 = /*#__PURE__*/_createVNode("th", {
  scope: "col",
  title: "employee member"
}, "EMPL", -1)
const _hoisted_73 = /*#__PURE__*/_createVNode("th", { scope: "col" }, "Name", -1)
const _hoisted_74 = /*#__PURE__*/_createVNode("th", { scope: "col" }, "Email", -1)
const _hoisted_75 = /*#__PURE__*/_createVNode("th", {
  scope: "col",
  title: "hourly rate"
}, "H.R.", -1)
const _hoisted_76 = /*#__PURE__*/_createVNode("th", { scope: "col" }, null, -1)
const _hoisted_77 = { key: 0 }
const _hoisted_78 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times-circle" }, null, -1)
const _hoisted_79 = {
  key: 1,
  class: "form-group"
}
const _hoisted_80 = /*#__PURE__*/_createVNode("label", { for: "" }, "Upload Attachement", -1)
const _hoisted_81 = {
  key: 0,
  class: "image-in-chat preview-image-list"
}
const _hoisted_82 = { class: "row mx-n2" }
const _hoisted_83 = {
  key: 0,
  class: "shadowed-card bg-white mb-2 mr-2"
}
const _hoisted_84 = {
  key: 0,
  class: "loader-wrapper"
}
const _hoisted_85 = /*#__PURE__*/_createVNode("span", {
  class: "spinner-border",
  role: "status"
}, [
  /*#__PURE__*/_createVNode("span", { class: "sr-only" }, "Loading...")
], -1)
const _hoisted_86 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_87 = { class: "imaged-col" }
const _hoisted_88 = { class: "small-img-wrap" }
const _hoisted_89 = { class: "size" }
const _hoisted_90 = {
  key: 1,
  class: "shadowed-card bg-white mb-2"
}
const _hoisted_91 = {
  key: 0,
  class: "loader-wrapper"
}
const _hoisted_92 = /*#__PURE__*/_createVNode("span", {
  class: "spinner-border",
  role: "status"
}, [
  /*#__PURE__*/_createVNode("span", { class: "sr-only" }, "Loading...")
], -1)
const _hoisted_93 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_94 = { class: "imaged-col" }
const _hoisted_95 = { class: "small-img-wrap" }
const _hoisted_96 = { class: "size" }
const _hoisted_97 = {
  key: 2,
  class: "shadowed-card bg-white mb-2"
}
const _hoisted_98 = {
  key: 0,
  class: "loader-wrapper"
}
const _hoisted_99 = /*#__PURE__*/_createVNode("span", {
  class: "spinner-border",
  role: "status"
}, [
  /*#__PURE__*/_createVNode("span", { class: "sr-only" }, "Loading...")
], -1)
const _hoisted_100 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_101 = { class: "imaged-col" }
const _hoisted_102 = /*#__PURE__*/_createVNode("div", { class: "small-img-wrap" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-file-word" })
], -1)
const _hoisted_103 = { class: "size" }
const _hoisted_104 = {
  key: 3,
  class: "media-wrap shadowed-card bg-white mb-2"
}
const _hoisted_105 = {
  key: 0,
  class: "loader-wrapper"
}
const _hoisted_106 = /*#__PURE__*/_createVNode("div", { class: "centered-wrap" }, [
  /*#__PURE__*/_createVNode("span", {
    class: "spinner-border big-spinner",
    role: "status"
  }, [
    /*#__PURE__*/_createVNode("span", { class: "sr-only" }, "Loading...")
  ])
], -1)
const _hoisted_107 = { class: "size" }
const _hoisted_108 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_109 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ErrorList = _resolveComponent("ErrorList")
  const _component_DebouncedCurrencyInput = _resolveComponent("DebouncedCurrencyInput")
  const _component_v_date_picker = _resolveComponent("v-date-picker")
  const _component_DragAndDropZone = _resolveComponent("DragAndDropZone")
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          (_ctx.editMode && _ctx.editFrom === 'phase')
            ? (_openBlock(), _createBlock("div", _hoisted_5, [
                _hoisted_6,
                _createVNode("button", {
                  type: "button",
                  class: "close",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.hideAddPhaseModal && _ctx.hideAddPhaseModal(...args))),
                  "aria-label": "Close"
                }, [
                  _hoisted_7
                ])
              ]))
            : (_openBlock(), _createBlock("div", _hoisted_8, [
                (_ctx.editFrom === 'createPhase')
                  ? (_openBlock(), _createBlock("h5", _hoisted_9, " Add Phase "))
                  : (_ctx.editMode && _ctx.editFrom === 'task')
                    ? (_openBlock(), _createBlock("h5", _hoisted_10, " Edit Task "))
                    : (_openBlock(), _createBlock("h5", _hoisted_11, "Add Task")),
                _createVNode("button", {
                  type: "button",
                  class: "close",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.hideAddPhaseModal && _ctx.hideAddPhaseModal(...args))),
                  "aria-label": "Close"
                }, [
                  _hoisted_12
                ])
              ])),
          _createVNode("div", _hoisted_13, [
            _createVNode(_component_ErrorList, {
              errors: _ctx.state.ui.error.errorList.createPhase,
              hasError: _ctx.state.ui.error.hasError
            }, null, 8, ["errors", "hasError"]),
            (_ctx.projectAcknowledgementDetail)
              ? (_openBlock(), _createBlock("div", _hoisted_14, [
                  _createVNode("div", _hoisted_15, [
                    _createVNode("div", _hoisted_16, [
                      (
                      !_ctx.phase ||
                      _ctx.editFrom === 'phase' ||
                      _ctx.editFrom === 'createPhase'
                    )
                        ? (_openBlock(), _createBlock("h3", _hoisted_17, [
                            _hoisted_18,
                            _createTextVNode(" Project Name- " + _toDisplayString(_ctx.projectDetail?.name), 1)
                          ]))
                        : (_openBlock(), _createBlock("h3", _hoisted_19, [
                            _hoisted_20,
                            _createTextVNode(" Phase Name- " + _toDisplayString(_ctx.phase?.name), 1)
                          ]))
                    ]),
                    _createVNode("div", _hoisted_21, [
                      _createVNode("ul", null, [
                        (_ctx.modelName == 'phase' || _ctx.editFrom === 'phase')
                          ? (_openBlock(), _createBlock("li", _hoisted_22, [
                              _hoisted_23,
                              _hoisted_24
                            ]))
                          : (_openBlock(), _createBlock("li", _hoisted_25, [
                              _hoisted_26,
                              _hoisted_27
                            ])),
                        _createVNode("li", _hoisted_28, _toDisplayString(_ctx.projectAcknowledgementDetail.start_date.slice(0, 10)), 1),
                        _hoisted_29,
                        _createVNode("li", _hoisted_30, _toDisplayString(_ctx.projectAcknowledgementDetail.end_date.slice(0, 10)), 1)
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createVNode("div", _hoisted_31, [
              _createVNode("div", _hoisted_32, [
                (!_ctx.editMode && !_ctx.phase)
                  ? (_openBlock(), _createBlock("label", _hoisted_33, "Name "))
                  : (_openBlock(), _createBlock("label", _hoisted_34, "Name ")),
                _withDirectives(_createVNode("input", {
                  type: "text",
                  class: "form-control",
                  id: "exampleInputEmail1",
                  "aria-describedby": "emailHelp",
                  disabled: _ctx.updateTask,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.state.data.phase.name = $event))
                }, null, 8, ["disabled"]), [
                  [_vModelText, _ctx.state.data.phase.name]
                ])
              ]),
              _createVNode("div", _hoisted_35, [
                _hoisted_36,
                _withDirectives(_createVNode("input", {
                  type: "text",
                  class: "form-control",
                  id: "exampleInputEmail1",
                  "aria-describedby": "emailHelp",
                  disabled: _ctx.updateTask,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.state.data.phase.description = $event))
                }, null, 8, ["disabled"]), [
                  [_vModelText, _ctx.state.data.phase.description]
                ])
              ]),
              _createVNode("div", _hoisted_37, [
                _createVNode("div", _hoisted_38, [
                  _createVNode("div", _hoisted_39, [
                    _hoisted_40,
                    _withDirectives(_createVNode("select", {
                      class: "form-control",
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.state.data.phase.priority = $event))
                    }, [
                      _hoisted_41,
                      _hoisted_42,
                      _hoisted_43
                    ], 512), [
                      [_vModelSelect, _ctx.state.data.phase.priority]
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_44, [
                  (!_ctx.editMode && !_ctx.phase)
                    ? (_openBlock(), _createBlock("div", _hoisted_45, [
                        _createVNode("div", _hoisted_46, [
                          _hoisted_47,
                          _createVNode(_component_DebouncedCurrencyInput, {
                            class: "form-control",
                            modelValue: _ctx.state.data.phase.estBudget,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.state.data.phase.estBudget = $event)),
                            options: {
                          currency: 'USD',
                          hideCurrencySymbolOnFocus: false,
                          hideGroupingSeparatorOnFocus: false,
                          hideNegligibleDecimalDigitsOnFocus: false,
                        }
                          }, null, 8, ["modelValue"])
                        ])
                      ]))
                    : (_openBlock(), _createBlock("div", _hoisted_48, [
                        _createVNode("div", _hoisted_49, [
                          _hoisted_50,
                          _withDirectives(_createVNode("input", {
                            class: "ml-3 mr-2",
                            type: "checkbox",
                            id: "vehicle1",
                            name: "vehicle1",
                            value: "Bike",
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.state.data.phase.checkPercentage = $event)),
                            disabled: _ctx.updateTask
                          }, null, 8, ["disabled"]), [
                            [_vModelCheckbox, _ctx.state.data.phase.checkPercentage]
                          ]),
                          _hoisted_51
                        ]),
                        _createVNode("div", _hoisted_52, [
                          (_ctx.state.data.phase.checkPercentage)
                            ? (_openBlock(), _createBlock("label", _hoisted_53, "Enter Percentage"))
                            : _createCommentVNode("", true),
                          (_ctx.state.data.phase.checkPercentage)
                            ? _withDirectives((_openBlock(), _createBlock("input", {
                                key: 1,
                                type: "number",
                                class: "form-control mb-2",
                                id: "exampleInputEmail1",
                                "aria-describedby": "emailHelp",
                                disabled: _ctx.updateTask,
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.state.data.phase.percentage = $event)),
                                min: "1",
                                max: "100"
                              }, null, 8, ["disabled"])), [
                                [_vModelText, _ctx.state.data.phase.percentage]
                              ])
                            : _withDirectives((_openBlock(), _createBlock("input", {
                                key: 2,
                                type: "number",
                                class: "form-control",
                                id: "exampleInputEmail1",
                                "aria-describedby": "emailHelp",
                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.state.data.phase.estBudget = $event)),
                                min: "1"
                              }, null, 512)), [
                                [_vModelText, _ctx.state.data.phase.estBudget]
                              ]),
                          (_ctx.state.data.phase.checkPercentage)
                            ? _withDirectives((_openBlock(), _createBlock("input", {
                                key: 3,
                                disabled: 
                          _ctx.state.data.phase.checkPercentage ? true : false
                        ,
                                type: "number",
                                class: "form-control",
                                id: "exampleInputEmail1",
                                "aria-describedby": "emailHelp",
                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.dispatchedAmount = $event)),
                                min: "1"
                              }, null, 8, ["disabled"])), [
                                [_vModelText, _ctx.dispatchedAmount]
                              ])
                            : _createCommentVNode("", true)
                        ])
                      ]))
                ])
              ]),
              _createVNode("div", _hoisted_54, [
                _createVNode("div", _hoisted_55, [
                  _createVNode("div", _hoisted_56, [
                    _hoisted_57,
                    _createVNode(_component_v_date_picker, {
                      modelValue: _ctx.state.data.phase.startDate,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.state.data.phase.startDate = $event)),
                      "min-date": _ctx.state.data.minDate,
                      "max-date": _ctx.state.data.maxDate
                    }, {
                      default: _withCtx(({ inputValue, inputEvents }) => [
                        _createVNode("input", _mergeProps({
                          class: "form-control",
                          value: inputValue
                        }, _toHandlers(inputEvents)), null, 16, ["value"])
                      ]),
                      _: 1
                    }, 8, ["modelValue", "min-date", "max-date"])
                  ])
                ]),
                _createVNode("div", _hoisted_58, [
                  _createVNode("div", _hoisted_59, [
                    _hoisted_60,
                    _createVNode(_component_v_date_picker, {
                      modelValue: _ctx.state.data.phase.endDate,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.state.data.phase.endDate = $event)),
                      "min-date": _ctx.state.data.endDateMindate,
                      "max-date": _ctx.state.data.maxDate
                    }, {
                      default: _withCtx(({ inputValue, inputEvents }) => [
                        _createVNode("input", _mergeProps({
                          class: "form-control",
                          value: inputValue
                        }, _toHandlers(inputEvents), {
                          disabled: _ctx.state.ui.isLoading.enableEndDate
                        }), null, 16, ["value", "disabled"])
                      ]),
                      _: 1
                    }, 8, ["modelValue", "min-date", "max-date"])
                  ])
                ]),
                (!_ctx.updateTask)
                  ? (_openBlock(), _createBlock("div", _hoisted_61, [
                      _createVNode("div", _hoisted_62, [
                        _hoisted_63,
                        _withDirectives(_createVNode("select", {
                          disabled: 
                        _ctx.state.data.existingMembers.members &&
                        _ctx.state.data.existingMembers.members.length === 0
                      ,
                          class: "form-control mb-2",
                          id: "user.id",
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.state.data.phase.existedMembers = $event)),
                          onChange: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.changeInviteMember && _ctx.changeInviteMember(...args)))
                        }, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.existingMembers
                          .members, (item, itemIndex) => {
                            return (_openBlock(), _createBlock("option", {
                              value: item.email,
                              key: itemIndex
                            }, _toDisplayString(item.full_name) + " (" + _toDisplayString(item.email) + ") ", 9, ["value"]))
                          }), 128))
                        ], 40, ["disabled"]), [
                          [_vModelSelect, _ctx.state.data.phase.existedMembers]
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.updateTask)
                  ? (_openBlock(), _createBlock("div", _hoisted_64, [
                      _createVNode("div", _hoisted_65, [
                        _hoisted_66,
                        _createVNode("div", _hoisted_67, [
                          _withDirectives(_createVNode("input", {
                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.state.data.invite.newUsers = $event)),
                            type: "email",
                            class: "form-control",
                            id: "exampleInputEmail1",
                            "aria-describedby": "emailHelp",
                            placeholder: "Type email and press enter or click add button",
                            onKeydown: _cache[16] || (_cache[16] = _withKeys(
//@ts-ignore
(...args) => (_ctx.changeInviteMember && _ctx.changeInviteMember(...args)), ["enter"]))
                          }, null, 544), [
                            [_vModelText, _ctx.state.data.invite.newUsers]
                          ]),
                          _createVNode("button", {
                            onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.changeInviteMember && _ctx.changeInviteMember(...args)))
                          }, [
                            _hoisted_68
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              (
                  _ctx.state.data.invite.invites && _ctx.state.data.invite.invites.length
                )
                ? (_openBlock(), _createBlock("div", _hoisted_69, [
                    _createVNode("table", _hoisted_70, [
                      _createVNode("thead", null, [
                        _createVNode("tr", null, [
                          (!_ctx.phase)
                            ? (_openBlock(), _createBlock("th", _hoisted_71, " CONTR "))
                            : _createCommentVNode("", true),
                          _hoisted_72,
                          _hoisted_73,
                          _hoisted_74,
                          _hoisted_75,
                          _hoisted_76
                        ])
                      ]),
                      _createVNode("tbody", null, [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.invite.invites, (invite, inviteIndex) => {
                          return (_openBlock(), _createBlock("tr", { key: inviteIndex }, [
                            (!_ctx.phase)
                              ? (_openBlock(), _createBlock("td", _hoisted_77, [
                                  _withDirectives(_createVNode("input", {
                                    class: "form-check-input ml-0",
                                    type: "checkbox",
                                    value: "",
                                    "onUpdate:modelValue": ($event: any) => (invite.sub_contractor = $event),
                                    onChange: ($event: any) => (_ctx.contractorChange(invite)),
                                    "aria-label": "Checkbox for following text input"
                                  }, null, 40, ["onUpdate:modelValue", "onChange"]), [
                                    [_vModelCheckbox, invite.sub_contractor]
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            _createVNode("td", null, [
                              _withDirectives(_createVNode("input", {
                                class: "form-check-input ml-0",
                                type: "checkbox",
                                value: "",
                                "aria-label": "Checkbox for following text input",
                                "onUpdate:modelValue": ($event: any) => (invite.member = $event),
                                onChange: ($event: any) => (_ctx.memberChange(invite))
                              }, null, 40, ["onUpdate:modelValue", "onChange"]), [
                                [_vModelCheckbox, invite.member]
                              ])
                            ]),
                            _createVNode("td", null, [
                              _withDirectives(_createVNode("input", {
                                type: "text",
                                id: "nameMember",
                                "aria-describedby": "emailHelp",
                                "onUpdate:modelValue": ($event: any) => (invite.name = $event)
                              }, null, 8, ["onUpdate:modelValue"]), [
                                [_vModelText, invite.name]
                              ])
                            ]),
                            _createVNode("td", null, _toDisplayString(invite.email), 1),
                            _createVNode("td", null, [
                              _withDirectives(_createVNode("input", {
                                class: 
                            invite.error
                              ? 'hour-limit-input input-warning'
                              : 'hour-limit-input'
                          ,
                                type: "number",
                                id: "hourlyForMember",
                                "aria-describedby": "emailHelp",
                                "onUpdate:modelValue": ($event: any) => (invite.hourly = $event)
                              }, null, 10, ["onUpdate:modelValue"]), [
                                [_vModelText, invite.hourly]
                              ])
                            ]),
                            _createVNode("td", null, [
                              _createVNode("a", {
                                class: "text-danger",
                                href: "javascript:void(0)",
                                onClick: ($event: any) => (_ctx.removeSelectedUser(invite))
                              }, [
                                _hoisted_78
                              ], 8, ["onClick"])
                            ])
                          ]))
                        }), 128))
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (!_ctx.updateTask)
                ? (_openBlock(), _createBlock("div", _hoisted_79, [
                    _hoisted_80,
                    _createVNode(_component_DragAndDropZone, {
                      onDrop: _withModifiers(_ctx.dropFiles, ["prevent"]),
                      onDropFiles: _ctx.dropFiles
                    }, null, 8, ["onDrop", "onDropFiles"]),
                    (
                    _ctx.state.data.imagesToUpload &&
                    _ctx.state.data.imagesToUpload.length
                  )
                      ? (_openBlock(), _createBlock("div", _hoisted_81, [
                          _createVNode("div", _hoisted_82, [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.imagesToUpload, (image, imageIndex) => {
                              return (_openBlock(), _createBlock("div", { key: imageIndex }, [
                                (
                          image.extension === 'jpg' ||
                          image.extension === 'png' ||
                          image.extension === 'jpeg' ||
                          image.extension === 'gif'
                        )
                                  ? (_openBlock(), _createBlock("div", _hoisted_83, [
                                      (image.isuploded)
                                        ? (_openBlock(), _createBlock("div", _hoisted_84, [
                                            _hoisted_85
                                          ]))
                                        : _createCommentVNode("", true),
                                      _createVNode("a", {
                                        class: "remove-btnn",
                                        href: "javascript:void(0)",
                                        onClick: ($event: any) => (_ctx.removeSelectedImage(image))
                                      }, [
                                        _hoisted_86
                                      ], 8, ["onClick"]),
                                      _createVNode("div", _hoisted_87, [
                                        _createVNode("div", _hoisted_88, [
                                          _createVNode("img", {
                                            src: image.file,
                                            alt: "",
                                            height: "200"
                                          }, null, 8, ["src"])
                                        ]),
                                        _createVNode("h5", null, _toDisplayString(image?.name), 1),
                                        _createVNode("p", _hoisted_89, _toDisplayString(image.size), 1)
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (image.extension === 'pdf')
                                  ? (_openBlock(), _createBlock("div", _hoisted_90, [
                                      (image.isuploded)
                                        ? (_openBlock(), _createBlock("div", _hoisted_91, [
                                            _hoisted_92
                                          ]))
                                        : _createCommentVNode("", true),
                                      _createVNode("a", {
                                        class: "remove-btnn",
                                        href: "javascript:void(0)",
                                        onClick: ($event: any) => (_ctx.removeSelectedImage(image))
                                      }, [
                                        _hoisted_93
                                      ], 8, ["onClick"]),
                                      _createVNode("div", _hoisted_94, [
                                        _createVNode("div", _hoisted_95, [
                                          _createVNode("img", {
                                            src: 
                                _ctx.state.data.imageBaseUrl
                                  ? `${_ctx.state.data.imageBaseUrl}img/pdf.jpg`
                                  : 'img/pdf.jpg'
                              ,
                                            alt: ""
                                          }, null, 8, ["src"])
                                        ]),
                                        _createVNode("h5", null, _toDisplayString(image?.name), 1),
                                        _createVNode("p", _hoisted_96, _toDisplayString(image.size), 1)
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (
                          image.extension === 'doc' ||
                          image.extension === 'docx'
                        )
                                  ? (_openBlock(), _createBlock("div", _hoisted_97, [
                                      (image.isuploded)
                                        ? (_openBlock(), _createBlock("div", _hoisted_98, [
                                            _hoisted_99
                                          ]))
                                        : _createCommentVNode("", true),
                                      _createVNode("a", {
                                        class: "remove-btnn",
                                        href: "javascript:void(0)",
                                        onClick: ($event: any) => (_ctx.removeSelectedImage(image))
                                      }, [
                                        _hoisted_100
                                      ], 8, ["onClick"]),
                                      _createVNode("div", _hoisted_101, [
                                        _hoisted_102,
                                        _createVNode("h5", null, _toDisplayString(image.name), 1),
                                        _createVNode("p", _hoisted_103, _toDisplayString(image.size), 1)
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (
                          image.extension === 'mp4' ||
                          image.extension === 'mov' ||
                          image.extension === 'MOV' ||
                          image.extension === 'wmv' ||
                          image.extension === 'webm' ||
                          image.extension === 'ogg' ||
                          image.extension === 'avi' ||
                          image.extension === 'x-ms-wmv'
                        )
                                  ? (_openBlock(), _createBlock("div", _hoisted_104, [
                                      (image.isuploded)
                                        ? (_openBlock(), _createBlock("div", _hoisted_105, [
                                            _hoisted_106
                                          ]))
                                        : _createCommentVNode("", true),
                                      _createVNode("img", {
                                        src: 
                            _ctx.state.data.imageBaseUrl
                              ? `${_ctx.state.data.imageBaseUrl}img/video-icon.png`
                              : 'img/video-icon.png'
                          ,
                                        alt: "",
                                        height: "200"
                                      }, null, 8, ["src"]),
                                      _createVNode("h5", null, _toDisplayString(image.name), 1),
                                      _createVNode("p", _hoisted_107, _toDisplayString(image.size), 1),
                                      _createVNode("a", {
                                        class: "remove-btnn",
                                        href: "javascript:void(0)",
                                        onClick: ($event: any) => (_ctx.removeSelectedImage(image))
                                      }, [
                                        _hoisted_108
                                      ], 8, ["onClick"])
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                            }), 128))
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createVNode("div", _hoisted_109, [
            _createVNode(_component_Button, {
              buttonName: _ctx.state.data.buttonName,
              buttonLoading: _ctx.state.ui.isPostLoading.createPhase,
              onButtonTrigger: _ctx.update
            }, null, 8, ["buttonName", "buttonLoading", "onButtonTrigger"]),
            _createVNode("button", {
              type: "button",
              class: "btn secondary-btn",
              onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.hideAddPhaseModal && _ctx.hideAddPhaseModal(...args)))
            }, " Close ")
          ])
        ])
      ])
    ])
  ]))
}